import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { RootState } from 'reducers/rootReducer'
import { sendFeedback } from 'actions/actionMenu.action'
import IFeedback from 'models/IFeedback'

export interface FeedbackBoxProps {
  title: string
  setShowFeedbackBox: React.Dispatch<React.SetStateAction<boolean>>
}

export const useFeedbackBox = (props: FeedbackBoxProps) => {
  const { restaurantName } = useParams<{ restaurantName: string }>()

  const [rating, setRating] = useState(0)
  const [comment, setComment] = useState('')
  const [isError, setIsError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const dispatch = useAppDispatch()

  const isLoading: boolean = useSelector(
    (state: RootState) => state.actionMenu.isLoading
  )
  const isSendFeedbackSuccess: boolean | null = useSelector(
    (state: RootState) => state.actionMenu.isSendFeedbackSuccess
  )
  const sendFeedbackResponseMessage: string | null = useSelector(
    (state: RootState) => state.actionMenu.sendFeedbackResponseMessage
  )
  const boxBgColor: string | undefined = useSelector(
    (state: RootState) =>
      state.restaurantInfo.restaurantInfo?.colors.popupBackground
  )
  const boxTitleColor: string | undefined = useSelector(
    (state: RootState) => state.restaurantInfo.restaurantInfo?.colors.popupTitle
  )
  const btnSubmitBgColor: string | undefined = useSelector(
    (state: RootState) =>
      state.restaurantInfo.restaurantInfo?.colors.popupButtonBackground
  )
  const btnSubmitTextColor: string | undefined = useSelector(
    (state: RootState) =>
      state.restaurantInfo.restaurantInfo?.colors.popupButtonText
  )

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    setIsError(false)
    setErrorMessage('')

    if (!rating) {
      setIsError(true)
      setErrorMessage('Please choose a star rating before submitting.')
      return
    }

    const feedback: IFeedback = {
      slug: restaurantName || '',
      rating,
      comment,
    }

    dispatch(sendFeedback(feedback))
  }

  useEffect(() => {
    if (isSendFeedbackSuccess) {
      setRating(0)
      setComment('')
    }
  }, [isSendFeedbackSuccess])

  return {
    ...props,
    rating,
    comment,
    sendFeedbackResponseMessage,
    isLoading,
    isSendFeedbackSuccess,
    isError,
    errorMessage,
    boxBgColor,
    boxTitleColor,
    btnSubmitBgColor,
    btnSubmitTextColor,
    setRating,
    setComment,
    onSubmit,
  }
}
